import { gql } from 'apollo-angular'

export default gql`
  mutation delete_report_by_pk($id: Int!) {
    delete_report(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`
